import * as tslib_1 from "tslib";
// Third party packages
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
// Custom packages
import { TranslateService } from "@ngx-translate/core";
import { ApiService } from "src/app/shared/services/api.service";
import { HelperService } from "src/app/shared/services/helper.service";
import * as i0 from "@angular/core";
import * as i1 from "../../shared/services/api.service";
import * as i2 from "../../shared/services/helper.service";
import * as i3 from "@ngx-translate/core";
var BalancesService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function BalancesService(apiService, helperService, translateService) {
        this.apiService = apiService;
        this.helperService = helperService;
        this.translateService = translateService;
    }
    /**
     * Create a new balance
     *
     * @since 1.0.0
     *
     * @param balance Balance data
     * @returns Observable<any>
     */
    BalancesService.prototype.create = function (balance) {
        return this.apiService.apiCall("POST", "balances", balance);
    };
    /**
     * Get balances list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    BalancesService.prototype.getList = function (start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "balances", params);
    };
    /**
     * Get balances list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    BalancesService.prototype.getPropertyList = function (propertyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            search = tslib_1.__assign({}, search, { propertyId: propertyId });
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "balances", params);
    };
    /**
     * Get balances list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    BalancesService.prototype.getCompanyList = function (companyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            search = tslib_1.__assign({}, search, { companyId: companyId });
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall("GET", "balances", params);
    };
    /**
     * Get an exportation file of all balances
     *
     * @since 1.0.0
     */
    BalancesService.prototype.getExport = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "balances/export", {}, { responseType: "blob" })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all closed balances
     *
     * @since 1.0.0
     */
    BalancesService.prototype.getExportClosed = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "balances/export-closed", {}, { responseType: "blob" })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all open first balances
     *
     * @since 1.0.0
     */
    BalancesService.prototype.getExportOpenFirst = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "balances/export-open-first", {}, { responseType: "blob" })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all open following balances
     *
     * @since 1.0.0
     */
    BalancesService.prototype.getExportOpenFollowing = function () {
        var _this = this;
        return this.apiService
            .apiCall("GET", "balances/export-open-following", {}, { responseType: "blob" })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all balances
     *
     * @since 1.0.0
     */
    BalancesService.prototype.getExportCompany = function (companyId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "balances/export-company/" + companyId, {}, { responseType: "blob" })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get an exportation file of all balances
     *
     * @since 1.0.0
     */
    BalancesService.prototype.getExportProperty = function (propertyId) {
        var _this = this;
        return this.apiService
            .apiCall("GET", "balances/export-property/" + propertyId, {}, { responseType: "blob" })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    /**
     * Get given balanceId data from back-end
     *
     * @since 1.0.0
     *
     * @param balanceId ID of the balance to get
     */
    BalancesService.prototype.get = function (balanceId) {
        var _this = this;
        return this.apiService.apiCall("GET", "balances/" + balanceId).pipe(catchError(function (err) {
            _this.helperService.handleError(err);
            return throwError(err);
        }));
    };
    /**
     * Update balance with given balanceId with given balance data
     *
     * @since 1.0.0
     *
     * @param balanceId ID of balance to update
     * @param data New balance's data
     */
    BalancesService.prototype.update = function (balanceId, data) {
        return this.apiService.apiCall("PUT", "balances/" + balanceId, data);
    };
    /**
     * Update balance status
     *
     * @since 1.0.0
     *
     * @param balanceId ID of balance to update
     * @param status New balance's data
     */
    BalancesService.prototype.changeStatus = function (balanceId, data) {
        return this.apiService.apiCall("PATCH", "balances/" + balanceId, data);
    };
    /**
     * Delete permanently a balance
     *
     * @since 1.0.0
     *
     * @param balanceId ID of the balance
     */
    BalancesService.prototype.delete = function (balanceId) {
        return this.apiService.apiCall("DELETE", "balances/" + balanceId);
    };
    /**
     * Delete permanently a note balance
     *
     * @since 1.0.0
     *
     * @param balanceId ID of the balance
     * @param noteId ID of the note
     */
    BalancesService.prototype.deleteNote = function (balanceId, noteId) {
        return this.apiService.apiCall("DELETE", "balances/" + balanceId + "/notes/" + noteId);
    };
    /**
     * Update balance status
     *
     * @since 1.0.0
     *
     * @param balanceId ID of balance to update
     * @param noteId ID of the note to update (sent in the body, not in the URL)
     * @param data New text of note
     */
    BalancesService.prototype.updateNote = function (balanceId, noteId, data) {
        return this.apiService.apiCall("PUT", "balances/" + balanceId + "/notes", { noteId: noteId, text: data.text });
    };
    BalancesService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BalancesService_Factory() { return new BalancesService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService), i0.ɵɵinject(i3.TranslateService)); }, token: BalancesService, providedIn: "root" });
    return BalancesService;
}());
export { BalancesService };
